import { useEffect } from 'react';    
import { Link } from 'react-router-dom';    
import { useAuth } from '../contexts/AuthContext';    
import {
  UserCircleIcon,            
  ChatBubbleLeftRightIcon,   
  BookOpenIcon    
} from '@heroicons/react/24/outline';    
  
// Base navigation cards that are always visible  
const baseNavigationCards = [    
  {    
    name: 'Talk to Agent',    
    description: 'Talk with your AI Agent',    
    href: '/chat',    
    icon: UserCircleIcon,    
    bgColor: 'bg-cyan-500',    
  },    
  {    
    name: 'View Conversations',    
    description: 'Access conversation history',    
    href: '/conversations',    
    icon: ChatBubbleLeftRightIcon,    
    bgColor: 'bg-emerald-500',    
  },
  {      
    name: 'Add Memories',      
    description: 'Add knowledge to your agent',      
    href: '/addmemories',      
    icon: BookOpenIcon,      
    bgColor: 'bg-purple-500',      
  },  
];    
  
// Admin-only cards  
const adminCards = [  
 
];  
  
export default function Dashboard() {    
  const { hasAdminTenant, user } = useAuth();  
  
  useEffect(() => {    
    console.log('user: ' + JSON.stringify(user))  
  }, [user]);    
      
  const navigationCards = hasAdminTenant()     
    ? [...adminCards, ...baseNavigationCards]    
    : baseNavigationCards;    
    
  return (    
    <div className="py-6">    
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">    
        <h1 className="text-2xl font-semibold text-gray-900">Dashboard</h1>    
      </div>    
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">    
        <div className="mt-8">    
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">    
            {navigationCards.map((card) => (    
              <Link    
                key={card.name}    
                to={card.href}    
                className="relative flex flex-col overflow-hidden rounded-lg bg-white shadow transition hover:shadow-lg"    
              >    
                <div className="flex flex-1 flex-col p-6">    
                  <div className={`rounded-md ${card.bgColor} p-3 w-12 h-12 flex items-center justify-center`}>    
                    <card.icon className="h-6 w-6 text-white" aria-hidden="true" />    
                  </div>    
                  <div className="mt-4">    
                    <h3 className="text-lg font-medium text-gray-900">    
                      {card.name}    
                    </h3>    
                    <p className="mt-2 text-sm text-gray-500">    
                      {card.description}    
                    </p>    
                  </div>    
                </div>    
                <div className="flex items-center justify-end bg-gray-50 px-6 py-3">    
                  <span className="text-sm font-medium text-cyan-600">    
                    View section →    
                  </span>    
                </div>    
              </Link>    
            ))}    
          </div>    
        </div>    
      </div>    
    </div>    
  );    
}  
